import Vue from 'vue'
import {Component, Prop, Watch} from 'vue-property-decorator'
import {validationMixin} from 'vuelidate'
import {isEqualObject} from '@/helpers'
import {namespace} from 'vuex-class'

const uiModule = namespace('ui')

@Component({
  mixins: [validationMixin]
})
export default class BaseForm extends Vue {
  @Prop(Object) data!: {}
  @Prop(Object) relation!: {}

  @uiModule.Getter('isEditGetter') isEdit: any
  @uiModule.Action('setIsEditAction') setIsEdit: any
  @uiModule.Action('resetIsEditAction') resetIsEdit: any

  model: any = null

  form: any = {}
  formDefault: any = {}

  @Watch('data', {deep: true})
  watchData(val: any) {
    if (val) {
      const Model = this.model
      const fields = new Model(val, this.relation).getFields()
      this.form = Object.assign({}, fields)
      this.formDefault = Object.assign({}, this.form)
    }
  }

  @Watch('form', {deep: true})
  watchForm(val: any) {
    if (!isEqualObject(this.formDefault, val)) {
      if (!this.isEdit) this.setIsEdit()
    } else {
      this.resetIsEdit()
    }
  }

  created() {
    const Model = this.model
    const fields = new Model(null, this.relation).getFields()
    this.form = Object.assign({}, fields)
    this.formDefault = Object.assign({}, this.form)
  }

  mounted() {
    if (this.data) {
      const Model = this.model
      const fields = new Model(this.data, this.relation).getFields()
      this.form = Object.assign({}, fields)
      this.formDefault = Object.assign({}, this.form)
    }
  }

  submitHandler(id: any) {
    this.$v.$touch()
    if (!this.$v.$invalid) {
      const Model = this.model
      const data = new Model(null, this.relation).setFields(this.form)
      this.$emit('onSubmit', data)
    } else {
      window.scrollTo(0, 0)
    }
  }

  cancelHandler(data: any) {
    this.resetIsEdit()
    this.$emit('onCancel')
  }

  resetHandler() {
    const Model = this.model
    const fields = new Model(null, this.relation).getFields()
    this.form = Object.assign({}, fields)
    this.formDefault = Object.assign({}, this.form)
  }
}
